// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';

export const RadioGroup = forwardRef<
	ElementRef<typeof RadioGroupPrimitive.Root>,
	Omit<ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>, 'className'> & {
		'aria-label': string;
	}
>(({ ...props }, ref) => {
	return <RadioGroupPrimitive.Root className="flex gap-0.5" {...props} ref={ref} />;
});

export const RadioGroupItem = forwardRef<
	ElementRef<typeof RadioGroupPrimitive.Item>,
	ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & { label: string }
>(({ label, ...props }, ref) => {
	return (
		<RadioGroupPrimitive.Item
			ref={ref}
			className="flex flex-col rounded-md border border-white/20 bg-white/15 text-[#aeb9d0] data-[state=checked]:border-[#38BDF8] data-[state=checked]:bg-[#38bff846]  data-[state=checked]:text-[#38BDF8] disabled:text-[#aeb9d0] px-2 py-1 text-captionSmall font-semibold justify-center"
			{...props}
		>
			{label}
		</RadioGroupPrimitive.Item>
	);
});
